import axios from "axios";
import { HttpResponse } from "./HttpResponse";

/**
 * Network error code
 */
export const networkErrorCode = 'ERR_NETWORK';
/**
 * Network error message
 */
export const networkErrorMessage = 'Network Error';
/**
 * Unknown error
 */
const unknownError = { errors: { desconocido: "Error del servidor desconocido." } };
/**
 * Generates a http response with a custom error
 * @param error A error response return by API request
 * @returns A {@link HttpResponse} with custom error
 */
export const catchErrorOnRequest = <TData>(error: any) => {
    if (axios.isAxiosError(error)) {
        if (!error.response) {
            if (error.code === networkErrorCode || error.message === networkErrorMessage) {
                if (error.request.response) {
                    return HttpResponse.error<TData>(error.request.response);
                }
                return HttpResponse.error<TData>({ errors: { network: "Error de red: Favor de revisar tu conexión" } });
            }
        } else {
            return HttpResponse.error<TData>(error.response.data);
        }
    }
    return HttpResponse.error<TData>(unknownError);
}